// eslint-disable-next-line import/no-relative-parent-imports
import '../scss/main.scss'; // eslint-disable-line import/no-unassigned-import
import { homeSlider, grantBranchSlider } from './slider';
import autocomplete from './autocomplete';
import megaMenu from './megamenu';

// @ts-ignore 2ClickIframePrivacy is not ready for clean TypeScript imports
import TwoClickIframePrivacy from '../javascript/2ClickIframePrivacy.js'; // eslint-disable-line import/no-relative-parent-imports

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
window._2ClickIframePrivacy = TwoClickIframePrivacy._2ClickIframePrivacy; // eslint-disable-line @typescript-eslint/no-unsafe-assignment

function triggerButton (this: HTMLElement, event: KeyboardEvent): void {
    if (event.key === ' ' || event.key === 'Spacebar') { // IE11: Spacebar
        this.click();
        event.preventDefault();
    }
}

function expandableOnclickToggle (expandableToggleButton: HTMLElement): void {
    if (expandableToggleButton.getAttribute('aria-expanded') === 'false') {
        expandableToggleButton.setAttribute('aria-expanded', 'true');
    } else {
        expandableToggleButton.setAttribute('aria-expanded', 'false');
    }
}

function attachLargeHeaderScrollObserver (): void {
    const header = document.querySelector('header');
    const pixel = document.querySelector('#scroll-spy-header');
    if (header && pixel) {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) { // ie is the pixel visible in the viewport
                header.classList.add('large-header');
            } else {
                header.classList.remove('large-header');
            }
        });
        observer.observe(pixel);
    }
}

function toggleSearchFacets (this: HTMLElement): void {
    const facetsSelector = this.parentElement as HTMLElement;
    if (this.getAttribute('aria-expanded') === 'false') {
        facetsSelector.classList.add('expanded');
        this.setAttribute('aria-expanded', 'true');
    } else {
        facetsSelector.classList.remove('expanded');
        this.setAttribute('aria-expanded', 'false');
    }
}

function hideSearchFacets (this: HTMLElement, event: Event): void {
    if (!this.contains((event as FocusEvent).relatedTarget as Node)) {
        const facetsSelector = this.previousElementSibling as HTMLElement;
        facetsSelector.classList.remove('expanded');
        facetsSelector.querySelector('button')?.setAttribute('aria-expanded', 'false');
    }
}

function attachSearchScrollObserver (): void {
    const solrSearchForm = document.querySelector('main .search-form');
    const pixel = document.querySelector('#scroll-spy-search');

    if (solrSearchForm && pixel) {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) { // ie is the pixel visible in the viewport
                solrSearchForm.classList.remove('scrolled');
            } else {
                solrSearchForm.classList.add('scrolled');
            }
        });
        observer.observe(pixel);
    }
}

function updateCssViewportHeightProperty (): void {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function workOnDom (): void {
    const linkButtonElements = document.querySelectorAll<HTMLElement>('a[role=button]');
    for (const linkButtonElement of linkButtonElements) {
        linkButtonElement.addEventListener('keydown', triggerButton.bind(linkButtonElement));
    }

    for (const expandableToggleButton of document.querySelectorAll<HTMLElement>('.ce-expandabletext button')) {
        expandableToggleButton.addEventListener('click', () => {
            expandableOnclickToggle(expandableToggleButton);
        });
    }

    for (const button of document.querySelectorAll('.search-facet-selector button')) {
        button.addEventListener('click', toggleSearchFacets);
    }
    for (const list of document.querySelectorAll('.search-facet-list')) {
        list.addEventListener('focusout', hideSearchFacets);
    }

    megaMenu('.header-menu');
    grantBranchSlider();

    const firstHomeSliderImage = document.querySelector<HTMLImageElement>('#home-swiper-wrapper .swiper-slide:first-child figure img');
    if (firstHomeSliderImage) {
        if (firstHomeSliderImage.complete) {
            homeSlider();
        } else {
            firstHomeSliderImage.addEventListener('load', () => homeSlider());
        }
    }

    attachLargeHeaderScrollObserver();
    attachSearchScrollObserver();

    autocomplete();

    if (window._2ClickIframePrivacyConfig) {
        window._2ClickIframePrivacy.init(window._2ClickIframePrivacyConfig);
    }
}

// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
updateCssViewportHeightProperty();
window.addEventListener('resize', () => {
    updateCssViewportHeightProperty();
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => workOnDom());
} else {
    workOnDom();
}
